module.exports = __webpack_public_path__ + "static/confetti-0a96e6d377670579f07fdba955964248.gif";